import YYPagination from './pagination'

export default YYPagination